module.exports = __webpack_public_path__ + "img/矩形 18 拷贝.61f62a3d.png";